import {SpielerRollenService} from "@/services/data/spieler/spielerRollen";
import FirebaseWrite from "@/services/database/firebaseWrite";
import TimeStamp from "@/services/timeStamp";

export class PrintPaesseEditPrintStatus {
    constructor(spieler, spielerPassLabel) {
        this.passList = []
        this.dateLocaleOptionsLong = {year: "numeric", month: "numeric", day: "numeric",
            hour: "numeric", minute: "numeric"}
        this.addSpielerPass(spieler, spielerPassLabel)
        this.addOtherPasses(spieler)
        this.spielerId = spieler.id
    }

    addSpielerPass(spieler,spielerPassLabel){
        this.passList.push({type: 'sp',
                            sort: 1,
                            label: spielerPassLabel,
                            isDuplikat: spieler.printIsDuplikat,
                            tsLastPassPrint: this.getFormatedPassPrintTs(spieler.tsLastPlayerPassPrint),
                            waitingForPassPrint: spieler.waitingForPlayerPassPrint})
    }

    addOtherPasses(spieler){
        if ( !spieler.roles ) return
        const spielerRollen = new SpielerRollenService(spieler.roles)
        Object.keys(spieler.roles).forEach( (roleKey) => {
            if ( roleKey !== 'isSchiedsrichter' && roleKey !== 'isTrainer' ) {
                const role = spieler.roles[roleKey]
                this.passList.push({type: roleKey,
                    label: spielerRollen.getFullRoleName(roleKey),
                    sort: spielerRollen.getSort(roleKey),
                    tsLastPassPrint: this.getFormatedPassPrintTs(role.tsLastPassPrint),
                    waitingForPassPrint: role.waitingForPassPrint})
            }
        });
        this.passList.sort((a, b) => a.sort > b.sort ? 1 : -1);
    }
        getFormatedPassPrintTs(tsLastPassPrint){
            return tsLastPassPrint === 0 || !tsLastPassPrint ?
            'unbekannt' : TimeStamp.getLocalDateAndTime(tsLastPassPrint)
        }

    saveChanges(){
        const spielerPass = this.passList.find(pass=>pass.type==='sp');
        let updateObject = {
            waitingForPlayerPassPrint: spielerPass.waitingForPassPrint,
            printIsDuplikat: spielerPass.isDuplikat,
            waitingForPassPrint: this.passList.filter(pass=>pass.waitingForPassPrint).length > 0,
        }
        updateObject = this.addOtherPassesToSaveObject(updateObject)
        FirebaseWrite.mergeFirebaseDocWithId('spieler', this.spielerId,updateObject)
    }

        addOtherPassesToSaveObject(updateObject){
            const otherPasses = this.passList.filter(pass=>pass.type!=='sp');
            if ( otherPasses.length === 0 ) return updateObject
            updateObject.roles = {}
            otherPasses.forEach( (pass) => {
                updateObject.roles[pass.type] = {waitingForPassPrint: pass.waitingForPassPrint}
            });
            return updateObject
        }

}